import {
  EstrategiaCalculoTributo,
  EstrategiaFormCatalogoProducto,
} from "../../interfaces/utils/estrategias-documentos.interface";
import {
  calcularTributoNoAplica,
  calcularTributoPorCantidadAplicaV1,
  mapearFormProductoConIvaYExentoV1,
  mapearFormProductoConTipoItemV1,
  mapearFormProductoSinCambios,
} from "./estrategias-documentos.v1";

export const mapearFormProductoConTipoItemV2: EstrategiaFormCatalogoProducto =
  mapearFormProductoConTipoItemV1;

export const mapearFormProductoConIvaYExentoV2: EstrategiaFormCatalogoProducto =
  mapearFormProductoConIvaYExentoV1;

export const mapearFormProductoSinCambiosV2: EstrategiaFormCatalogoProducto =
  mapearFormProductoSinCambios;

export const calcularTributoPorCantidadAplicaV2: EstrategiaCalculoTributo =
  calcularTributoPorCantidadAplicaV1;

export const calcularTributoNoAplicaV2: EstrategiaCalculoTributo = calcularTributoNoAplica;
